import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function WhyItFailedSection() {
  const reasons = ["La 'fuerza de voluntad' es un recurso biológico agotable que la depresión consume primero.", 'Los consejos motivacionales ignoran que tu cuerpo necesita seguridad física, no gritos de aliento.', "Intentar salir de la cama por 'culpa' aumenta el cortisol, lo que genera más parálisis y bloqueo.", 'La disciplina humana sin la Gracia Operativa es como intentar mover una montaña con las manos vacías.'];
  return <section className="py-20 md:py-24 px-6 bg-cream" data-id="element-159">
      <div className="max-w-3xl mx-auto" data-id="element-160">
        <FadeIn data-id="element-161">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-12 text-center" data-id="element-162">
            Por qué lo que has intentado no funcionó
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-163">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-164">
              <div className="flex items-start gap-4 p-6 bg-white rounded-2xl shadow-sm border border-divider/50" data-id="element-165">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center mt-1" data-id="element-166">
                  <svg className="w-4 h-4 text-sage" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-167">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-168" />
                  </svg>
                </div>
                <p className="text-lg text-navy/80 leading-relaxed" data-id="element-169">{reason}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}